<template>
    <center style="margin-top: 80px">
        <headful
            title="Caseen - 404"
        />
        <h1>404 - Not Found</h1>
        <h3>Sorry, but in this case we can't find what you're looking for!</h3>
        <br><br>
        <img src="/img/404.png" />
    </center>
</template>

<script>
    export default {
        
    }
</script>
